/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export default function uniqueId(id) {
    return id?.selector_id?.length ? id.selector_id : false;
}
